import useDynamicPage from "@/hooks/useDynamicPage";
import useDynamicPages from "@/hooks/useDynamicPages";
import { getHtmlLang } from "@/functions/getHtmlLang";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";
import { PoweredByBannerOffset } from "@/components/PoweredByBanner";

export default function SimplePage({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        title={seo?.title || title}
        description={seo?.description || ""}
        canonical={seo?.canonical || canonical}
        keywords={seo?.keywords || ""}
        robots={seo?.robots || ""}
        json_schema={seo?.json_schema || ""}
        image={seo?.open_graph?.image?.url || ""}
      />
      {canonical === "/us" && <PoweredByBannerOffset />}
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  const page = useDynamicPage(url_slug);

  if (page?.is_draft === true) {
    return { notFound: true };
  }

  return {
    props: {
      isBuilder: true,
      locale: url_slug === "us" || url_slug.startsWith("us/") ? "us" : "en",
      htmlLang: getHtmlLang(url_slug),
      prefix: `page_${url_slug.replaceAll(/[\/\-]/g, "_")}`,
      title: page.title,
      seo: page.seo,
      canonical: `/${url_slug}`,
      data: page.content,
    },
  };
}

export async function getStaticPaths() {
  const pages = useDynamicPages();
  const exclude = ["/"];
  const paths = pages
    .filter((i) => !exclude.includes(i.url_slug))
    .filter((i) => !i.is_draft)
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths,
    fallback: false,
  };
}
